export default __webpack_public_path__ + "static/media/Serenade-Schubert.a5157acc.mp3";